import { render, staticRenderFns } from "./EditUserGuide.vue?vue&type=template&id=3bb77932&scoped=true&"
import script from "./EditUserGuide.vue?vue&type=script&lang=js&"
export * from "./EditUserGuide.vue?vue&type=script&lang=js&"
import style0 from "./EditUserGuide.vue?vue&type=style&index=0&id=3bb77932&scoped=true&lang=scss&"
import style1 from "./EditUserGuide.vue?vue&type=style&index=1&id=3bb77932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb77932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb77932')) {
      api.createRecord('3bb77932', component.options)
    } else {
      api.reload('3bb77932', component.options)
    }
    module.hot.accept("./EditUserGuide.vue?vue&type=template&id=3bb77932&scoped=true&", function () {
      api.rerender('3bb77932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/EditUserGuide.vue"
export default component.exports